@if (this.surveyEditorService.surveyEditor$().activeHiddenQuestion; as activeHiddenQuestion) {
  <form [formGroup]="activeHiddenQuestion">
    <div class="question-form__array with-actions">
      <div class="header row">
        <span class="label">Options <span class="fs__xs caption">(Must have at least 2 options)</span></span>
      </div>

      <div formArrayName="options" cdkDropList class="question-form_array_list" (cdkDropListDropped)="drop($event)">
        @for (optionCtrl of options.controls; track $index) {
          <div cdkDrag class="question-form_array_draggable">
            <div [formGroupName]="$index" class="question-form__array__input">
              <div *cdkDragPlaceholder class="drag-placeholder"></div>
              <fa-icon [class.eiq-hide]="options.controls.length === 1" [icon]="faGripDotsVertical" title="Re-order option" cdkDragHandle></fa-icon>

              <empathy-text-editor
                [id]="optionCtrl.value.id"
                [control]="optionCtrl.get('text')"
                [autofocus]="justAddedOptionId === optionCtrl.value.id"
                [stopDefaultTab]="true"
                [splitOnPaste]="true"
                (tab)="onAddOption($last, $index)"
                (paste)="onPaste($event, $index)"
              >
                <div slot="prefix" class="eiq-id-badge">
                  <span>{{ optionCtrl.value.id }}</span>
                </div>
                <div slot="suffix" class="actions">
                  <button mat-icon-button color="primary" title="Option conditions" (click)="onOpenConditionals(optionCtrl)">
                    <fa-icon [icon]="faCodeBranch"></fa-icon>
                  </button>
                  @if (options.controls.length > 1) {
                    <button mat-icon-button color="warn" title="Delete Option" (click)="onRemoveAt($index)">
                      <fa-icon [icon]="faTrashCan"></fa-icon>
                    </button>
                  }
                </div>
              </empathy-text-editor>
              <fa-icon
                [class.eiq-hide]="optionCtrl.get('selectedWhen').value.length === 0"
                color="alert"
                [icon]="faCodeBranch"
                title="Option has conditions"
              ></fa-icon>
            </div>
          </div>
        }
      </div>

      <div class="footer">
        <button mat-button color="primary" [disabled]="!addOptionAllowed" (click)="onAddOption(true)">
          <fa-icon [icon]="faPlus"></fa-icon>
          New Option
        </button>
      </div>
    </div>
  </form>
}
